import React, { useEffect } from "react";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { DateInputWrapper } from "../../../DateInputWrapper";
import { TimeInputWrapper } from "../../../TimeInputWrapper";

export default function DateTime({
  isEditable,
  setStart,
  start,
  setEnd,
  end,
  endTimeError,
  endTimeErrorMsg,
}) {
  useEffect(() => {}, []);

  return (
    <fieldset className="form-group">
      <legend>Start Time</legend>
      <Row className="mb-3">
        <Col>
          <DateInputWrapper
            id="flex-pack-start"
            isReadOnly={!isEditable}
            setDate={setStart}
            selectedDate={start}
            startDate={start}
            size="sm"
          />
        </Col>
        <Col>
          <TimeInputWrapper
            id="flex-pack-start-time"
            isReadOnly={!isEditable}
            setDate={setStart}
            selectedDate={start}
            size="sm"
          />
        </Col>
      </Row>
      <legend>End Time</legend>
      <Row>
        <Col>
          <DateInputWrapper
            id="flex-pack-start"
            isReadOnly={!isEditable}
            setDate={setEnd}
            selectedDate={end}
            startDate={start}
            size="sm"
            error={endTimeError}
          />
        </Col>
        <Col>
          <TimeInputWrapper
            id="flex-pack-start-time"
            isReadOnly={!isEditable}
            setDate={setEnd}
            selectedDate={end}
            size="sm"
            error={endTimeError}
            errorMsg={endTimeErrorMsg}
          />
        </Col>
      </Row>
    </fieldset>
  );
}
